(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", (e) => {
      if (e.target.closest("button").matches(".faqs__item")) {
        const $item = e.target.closest(".faqs__item-container");
        $item.classList.toggle("active");
      }
    });
  });
})();
